import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { BasicModal, DefaultButton } from 'common/components';

import { staticStyles } from './style';

const AddressProofModal = ({ isOpen, modalType, onClose, onGoToDocuments }) => {
  const isRequired = modalType === 'required';

  return (
    <BasicModal isOpen={isOpen} onRequestClose={onClose} captionId="reminderText">
      <div className="AddressProofModal">
        <p className="AddressProofModal__description">
          {isRequired ? (
            <FormattedMessage id="clientWithdrawAddressProofRequiredDesc" />
          ) : (
            <FormattedMessage id="clientWithdrawAddressProofPendingDesc" />
          )}
        </p>
        <div className="AddressProofModal__buttons">
          {isRequired ? (
            <>
              <DefaultButton textId="clientWithdrawGoToDocuments" onClick={onGoToDocuments} filled />
              <DefaultButton textId="justCancel" onClick={onClose} />
            </>
          ) : (
            <>
              <DefaultButton textId="clientWithdrawCheckProgress" onClick={onGoToDocuments} filled />
              <DefaultButton textId="justCancel" onClick={onClose} />
            </>
          )}
        </div>
      </div>
      <style jsx global>
        {staticStyles}
      </style>
    </BasicModal>
  );
};

AddressProofModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  modalType: PropTypes.oneOf(['required', 'pending']).isRequired,
  onClose: PropTypes.func.isRequired,
  onGoToDocuments: PropTypes.func.isRequired,
};

export default AddressProofModal;
